<template>
  <div class="pupils bg-white !important">
    <div v-if="errored" class="empty p-2">
      <p>
        <i class="fas fa-exclamation-triangle pr-1 text-lg text-red-500"></i> We are not able to retrieve this information at the moment. <br/>
        Please try
        back later or if the issue persists contact our dedicated support team.
      </p>
    </div>

    <div id="content-area" v-else>
      <div style="width: 100%; text-align: center" v-if="loading">
        <i class="spinner fa fa-spinner fa-spin"></i>
      </div>

      <section v-else-if="componentLoaded">
        <div class="flex justify-between w-11/12 mb-1">
          <div class="relative grow ml-3 mb-3">
            <div
              class="
                flex
                absolute
                inset-y-0
                left-0
                items-center
                pl-3
                pointer-events-none
              "
            >
              <svg
                class="w-5 h-5 text-gray-500 dark:text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                ></path>
              </svg>
            </div>
            <input
              type="search"
              class="
                h-full
                text-gray-700
                placeholder-gray-500
                w-full
                bg-gray-100
                rounded
                shadow-sm
                p-1
                pl-10
                m-1
              "
              name="search"
              v-model="search"
              placeholder="Search pupils"
            />
          </div>
        </div>

        <table class="table-wrapper w-95p mx-auto mb-24">
          <thead>
            <tr class="bg-gray-200 text-xs">
              <th colspan="2" class="pl-3 py-2 text-left border w-5/12">
                Pupil
              </th>
              <th class="pl-3 py-2 border flex text-left">
                <ul class="mb-1 w-full">
                  <li
                    v-for="item in activity.weeks"
                    :key="item"
                    class="mr-2 w-5 inline-block"
                  >
                    W{{ item }}
                  </li>
                </ul>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="pupil in filteredList"
              :key="pupil.identifier"
              class="group w-full mx-auto p-3"
            >
              <td colspan="2" class="border-l border-r text-xs w-5/12">
                <div class="flex content-center pl-1">
                  <div
                    class="
                      w-8
                      h-8
                      rounded-full
                      text-center
                      bg-blue-100 bg-opacity-75
                      pt-1
                      mr-3
                    "
                  >
                    {{ getPupilInitials(pupil) }}
                  </div>

                  <span class="mt-1">{{ pupil.name }}</span>
                </div>
              </td>
              <td class="text-center text-lg">
                <ul class="mb-1 w-full text-left">
                  <li
                    v-for="week in activity.weeks"
                    :key="week"
                    class="mr-2 w-5 inline-block"
                  >
                    <button
                    @click="selectAttendance(pupil, week)"
                      type="button"
                      class="
                        cursor-pointer
                        hover:opacity-50
                        wide
                        focus:outline-none
                      "
                    >
                      <i
                        v-bind:class="[
                          inSelected(pupil, week)
                            ? 'fas fa-check-circle text-green-400'
                            : ' far fa-circle text-gray-300',
                        ]"
                      ></i>
                    </button>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="filteredList.length === 0">
            <tr>
            <td colspan="3">  We could not find any data for your given selection. <br/>
          Please amend your search criteria.</td>
        </tr>

          </tfoot>
        </table>

  
      </section>
      <p class="m-5" v-else>
          We could not find any data for your given selection. <br/>
          Please ensure you add pupils and weeks to the activity first.
          <br/>
          <a class=" text-purple-600 cursor-pointer hover:opacity-75"   @click="$emit('view')">View activity</a>
        </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ActivityService } from "@/services/activity.service";

export default {
  name: "pupils",
  mixins: [],
  props: {
    attendanceCriteria: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.selectedPupils.length > 0 && (this.activity.weeks != undefined)
    },
    showMessage() {
      return this.msg != undefined && this.msg.length > 0;
    },
    filteredList() {
      var vm = this;
      let results = this.selectedPupils.filter((item) => {
        return item.name.toLowerCase().includes(vm.search.toLowerCase());
      });

      return _.orderBy(results, ["name", "class"]);
    },
  },
  data() {
    return {
      search: "",
      activity: this.attendanceCriteria.activity,
      filteredClass: {},
      selectedPupils: [],
      attendance: [],
      loading: false,
      errored: false,
    };
  },
  created() {},
  mounted() {
    this.fetchPupils();
  },
  methods: {
    fetchPupils() {
      this.loading = true;

      ActivityService.getPupils(this.activity)
        .then((response) => (this.selectedPupils = response.data.data))
        .catch((err) => {
          console.log("activities pupils " + err);
          this.errored = true;
        })
        .finally(() => {
          this.fetchAttendance();
          this.loading = false;
        });
    },
    fetchAttendance() {
      ActivityService.getAttendances(this.activity)
        .then((response) => this.parseAttendance(response.data.data))
        .catch((err) => {
          console.log("Attendance " + err);
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    parseAttendance(data) {
      var vm = this;
      vm.attendance = data.filter((item) => {
        let filtered = true;
        filtered = item.term === vm.attendanceCriteria.term.key;

        if (filtered) {
          filtered = item.weekday === vm.attendanceCriteria.day.toLowerCase();
        }

        if (filtered) {
          filtered = item.period === vm.attendanceCriteria.time.time_value;
        }
        return filtered;
      });
    },
    setSearch() {
      this.showSearch = !this.showSearch;
      this.search = "";
    },
    getPupilInitials(pupil) {
      return pupil.name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .substring(0, 3);
    },
    inSelected(pupil, week) {
      let found = this.attendance.find((att) => {
        let weeks = att.attended.split(",").map(Number);
        return (
          att.register_identifier === pupil.identifier && weeks.includes(week)
        );
      });
      return found;
    },
    selectAttendance(pupil, week) {
      let vm = this
      var object = this.attendance.find((att) => att.register_identifier === pupil.identifier);

      if (object === undefined) {
        // new
        object = {
          "register_identifier": pupil.identifier,
            "activity_identifier": vm.activity.identifier,
            "period": vm.attendanceCriteria.time.time_value,
            "term": vm.attendanceCriteria.term.key,
            "weekday": vm.attendanceCriteria.day.toLowerCase(),
            "attended": week.toString(),
            "signed_out": ""
        }

      } else {
        // existing
        var weeks = object.attended.split(",").map(Number)
        if (weeks.includes(week)) {
         weeks = weeks.filter((w) => w !== week)
        } else {
          weeks.push(week)
        }

        object.attended = weeks.join(",")
      }

      ActivityService.processAttendance(this.activity, object)
            .then((response) => {
              if (object.identifier === undefined) {
                object.identifier = response.data.identifier;
                this.attendance.push(object)
              }
            })
            .catch((err) => {
              console.log("ATT DELETE error " + err);
              vm.errored = true
            });
     
            
    },
  },
  components: {},
};
</script>


<style scoped>
.table-wrapper td {
  padding: 0.6em !important;
}
</style>